import {DATA_TYPE} from '@constants/data-type.constant';

export class ModbusSignal {
  bitmask: number = 0;
  order: number = 0;
  name: string = '';
  type: DATA_TYPE | string = '';
  hasChanged?: boolean = false;
}